<template>
  <transition
    appear
    name="m-modal-renderer"
    @before-enter="setBodyOverflow"
    @after-leave="resetBodyOverflow"
  >
    <div v-if="hasSlotContent" class="m-modal-renderer">
      <MOverlay />
      <transition appear name="m-modal-renderer__modal">
        <div class="m-modal-renderer__modal">
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import MOverlay from '../../../layout/Overlay/MOverlay'

/**
 * A wrapper that slots a modal and displays it on the screen.
 * Provides animations, screen overlay (background dimming) and scrolling logic.
 */
export default {
  name: 'MModalRenderer',
  components: {
    MOverlay,
  },
  data() {
    return { hasSlotContent: false }
  },
  beforeUpdate() {
    this.hasSlotContent = this.checkForSlotContent()
  },
  created() {
    this.hasSlotContent = this.checkForSlotContent()
  },
  beforeUnmount() {
    this.resetBodyOverflow()
  },
  methods: {
    checkForSlotContent() {
      const checkForContent = (hasContent, node) => {
        return (
          hasContent ||
          typeof node.children === 'string' ||
          node.children.default().length
        )
      }
      return !!(
        this.$slots.default() &&
        this.$slots.default().reduce(checkForContent, false)
      )
    },
    /** Restores initial body overflow state  */
    resetBodyOverflow() {
      const { dataset, style, classList } = document.body

      if (typeof dataset.overflow === 'undefined' || dataset.overflow === '') {
        style.overflow = ''
      } else {
        style.overflow = dataset.overflow
        delete dataset.overflow
      }

      classList.remove('modal-open')
    },

    /** Prevents body scrolling */
    setBodyOverflow() {
      if (document.body) {
        const { classList, dataset, style } = document.body

        if (style.overflow) {
          // store body overflow state
          dataset.overflow = style.overflow
        }

        classList.add('modal-open')
        style.overflow = 'hidden'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.m-modal-renderer {
  // Fixes layering with the site header
  &,
  &__modal {
    position: relative;
    z-index: calc(var(--z-index-modal-overlay) + 1);
  }

  // Layered fade in, but simple fade out
  &-enter-active,
  &-leave-active {
    transition: opacity var(--animation);
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
  }

  &__modal-enter-active,
  &__modal-leave-active {
    transition: opacity var(--animation) calc(var(--animation-speed) * 0.5);
  }

  &__modal-enter-from,
  &__modal-leave-to {
    opacity: 0;
  }
}
</style>
